import { Link } from 'react-router-dom';

import { useCodexConstellations, type CodexConstellation } from './data/codex-constellations-api';
import { WorldNodeArt } from './explore/WorldNodeArt';
import { worldNodeArt } from './explore/world-node-art';
import './codex-constellations.css';

export function ConstellationCard({ item }: { item: CodexConstellation }) {
  const awakened = item.status === 'awakened';
  return (
    <article className="constellation-card" data-status={item.status}>
      <span className="realm-screen__eyebrow">
        {awakened ? 'Chronicle awakened' : 'A story to discover'}
      </span>
      <h3>{item.title}</h3>
      <ol className="constellation-chain" aria-label="Connect these three different stops in order">
        {item.node_classes.map((kind, index) => (
          <li key={`${index}-${kind}`} data-connected={index < item.completed_steps}>
            <WorldNodeArt kind={kind} />
            <span>{worldNodeArt(kind).label}</span>
          </li>
        ))}
      </ol>
      <p>{item.description}</p>
      <strong className="constellation-card__progress">
        {awakened
          ? 'Yours to keep'
          : `${item.completed_steps} / ${item.required_steps} connections awakened`}
      </strong>
    </article>
  );
}

export function CodexConstellations({ enabled }: { enabled: boolean }) {
  const query = useCodexConstellations(enabled);
  if (!enabled) return null;
  return (
    <section
      className="codex-constellations"
      id="constellations"
      aria-labelledby="constellations-title"
    >
      <header>
        <span className="realm-screen__eyebrow">Places become stories</span>
        <h2 id="constellations-title">Your constellations</h2>
        <p>
          Choose three different stops in this order. Walk and restore both connections with Weave
          to keep their story in your Codex.
        </p>
      </header>
      {query.isPending && <p role="status">Opening your chronicles…</p>}
      {query.isError && (
        <div role="status">
          <p>Your chronicles are resting. Try again when connected.</p>
          <button type="button" onClick={() => void query.refetch()}>
            Try again
          </button>
        </div>
      )}
      <div className="constellation-collection">
        {query.data?.constellations.map((item) => (
          <ConstellationCard key={item.recipe_code} item={item} />
        ))}
      </div>
      <Link className="constellation-explore" to="/explore">
        Choose your next connection in Explore →
      </Link>
    </section>
  );
}
